import { render, staticRenderFns } from "./ProformaItemsImport.vue?vue&type=template&id=430a3971&"
import script from "./ProformaItemsImport.vue?vue&type=script&lang=js&"
export * from "./ProformaItemsImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports